import { ICommand } from 'core-ts-types';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { RouterHelper } from '../../../../../global/helpers/router_helper';
import { APComponentStateModel } from '../../../../../global/models/ap_component_state_model';
import { APProgramSlotServant } from '../../../../../global/servants/ap_program_slot_servant';
import { MarkAsMetDialogQuery } from '../../queries/mark_as_met_dialog_query';

class MarkAsMetDialog {
  private showDialog: boolean = true;
  private comment: string = '';

  constructor(
    private ngMarkAsMetDialogQuery: MarkAsMetDialogQuery,
    private markAsMetSlotCommand: ICommand,
    private routerHelper: RouterHelper,
    private ngAPComponentStateModel: APComponentStateModel
  ) {}

  openedChanged($event: any) {
    this.showDialog = $event.detail.value;
    if (!this.showDialog) {
      return this.routerHelper.findStateAndGo('^.default');
    }
    return false;
  }

  markAsMet() {
    const slot = this.ngMarkAsMetDialogQuery.result.genericSlot;
    if (!slot) {
      return;
    }
    this.markAsMetSlotCommand(slot, this.comment).then(() => {
      this.closeDialog();
      if (APProgramSlotServant.isCourseProgramSlot(slot.programSlot)) {
        return;
      }
      this.ngAPComponentStateModel.courseGroupClose(slot.programSlot.id);
    });
  }

  closeDialog() {
    this.showDialog = false;
  }
}

angular.module('capability-ng-academic-planner').component('markAsMetDialog', {
  templateUrl:
    'capability-ng-academic-planner/src/global/components/mark_as_met/components/dialog/mark_as_met_dialog.html',
  controller: MarkAsMetDialog
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/mark_as_met/components/dialog/mark_as_met_dialog.ts